<template>
    <header class="">
        <div class="site-header">
            <ModalIdle v-if="isIdle" />
            <div v-if="dialogTermo">
                <b-modal size="lg"
                         :hide-header-close="true"
                         :no-close-on-backdrop="true"
                         :no-close-on-esc="true"
                         centered
                         v-model="dialogTermo"
                         :hide-footer="true"
                         title="Termo de uso">
                    <form>
                        <div class="row">
                            <div class="form-group col-md-12">
                                <div class="col-xs-9">
                                    <div style="
                      border: 1px solid #e5e5e5;
                      height: 300px;
                      overflow: auto;
                      padding: 10px;
                    ">
                                        <span v-html="termoUso.texto"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p>
                            <input type="checkbox"
                                   value="aceito"
                                   @click="aceito = !aceito"
                                   required />&nbsp;
                            {{ termoUso.textoAcordo }}
                        </p>
                        <button type="button"
                                class="btn btn-success float-right"
                                @click="confirmTermodeUso(termoUso)">
                            <span>Confirmar</span>
                        </button>
                    </form>
                </b-modal>
            </div>

            <div class="container">
                <div class="row">
                    <div class="logo-circulo">
                        <router-link to="/">
                            <img src="../assets/images/logo_cna_circulo.png"
                                 width="180"
                                 class="circulo" />
                            <img src="../assets/images/logo-cna.png"
                                 width="100"
                                 class="normal" />
                        </router-link>
                    </div>
                    <div class="col-md-6 py-1">
                        <div class="row">
                            <div class="col-8 col-md-7 mt-2 nome-usuario">
                                <h2>Olá, {{ user.nome }}</h2>
                                <strong>Bem-vindo ao Shopping CNA</strong>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 py-md-2">
                        <div class="row">
                            <div class="col-4 col-sm-6 d-flex align-items-center justify-content-center">
                                <div class="menu-header" v-if="cnaStore">
                                    <a href="/cnastore"
                                       class="text-danger d-flex flex-column ml-3">
                                        <span class="small text-center">Acesso </span>
                                        <img src="../../public/img/logo-cnastore.svg"
                                             width="75"
                                             height="28" />
                                    </a>
                                </div>
                            </div>

                            <div class="col-8 col-sm-6">
                                <div class="carrinho-header float-right float-xl-right"
                                     @click="logout()">
                                    <button type="button"
                                            class="btn btn-light text-danger bmd-btn-fab"
                                            v-b-tooltip
                                            title="Sair do Shopping.">
                                        <i class="material-icons">exit_to_app</i>
                                    </button>
                                </div>
                                <div class="menu-header float-left float-sm-right mr-sm-4 mt-1">
                                    <a :href="urlPessoaCNA" target="_blank" class="text-danger">
                                        <i class="material-icons">person</i>Meu perfil
                                    </a>

                                    <b-dropdown size="sm"
                                                right
                                                id="dropdown-1"
                                                toggle-class="text-decoration-none text-black m-0"
                                                class="m-0"
                                                variant="link">
                                        <b-dropdown-item :href="urlRedefinirSenha" target="_blank">
                                            <span class="text-danger">
                                                <i class="fa fa-lock"></i> Configurar nova senha
                                            </span>
                                        </b-dropdown-item>
                                    </b-dropdown>

                                    <br />
                                    <a href="javascript:;"
                                       @click="goToPedidos()"
                                       class="text-danger">
                                        <i class="material-icons">list</i>Meus pedidos
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="imagens && imagens.length > 0">
            <b-carousel id="carousel1"
                        class="text-center"
                        style="text-shadow: 1px 1px 2px #333"
                        controls
                        indicators
                        img-height="350"
                        :interval="4000">
                <div v-for="item in imagens">
                    <b-carousel-slide>
                        <img slot="img"
                             img-blank="true"
                             img-blank-color="transparent"
                             class="img-fluid"
                             :src="item.urlImagem"
                             :alt="item.nome"
                             style="max-height: 400px"
                             v-on:click="goToLinkEncaminhado(item.urlEncaminhado)" />
                    </b-carousel-slide>
                </div>
            </b-carousel>
        </div>
    </header>
</template>
<script>
    import Global from "@/common/global";
    import Auth from "@/common/auth";
    import base from "@/common/base";
    import { Api } from "@/common/api";
    import ModalIdle from "@/common/components/ModalIdle";
    import Vue from "vue";
    import Cache from "@/common/cache";

    import Vuex from "vuex";
    Vue.use(Vuex);
    const store = new Vuex.Store();
    import IdleVue from "idle-vue";

    Vue.use(IdleVue, {
        eventEmitter: Vue.prototype.$eventHub,
        store,
        idleTime: Cache.get(Auth.modalInatividade),
        startAtIdle: false,
    });

    export default {
        name: "header-cna",
        mixins: [base],
        components: {
            ModalIdle,
        },
        data() {
            return {
                user: {},
                imagens: [],
                dialogTermo: false,
                background: false,
                aceito: false,
                termoUso: {},
                cnaStore: false,
            };
        },
        watch: {
            $route(to) {
                this.getImagensCarrossel(to.path);
            },
        },
        computed: {
            urlPessoaCNA() {
                return Global.URL_CNA_ACCOUNT + "perfil/" + this.user.pessoaCNAId;
            },
            urlRedefinirSenha() {
                return Global.URL_CNA_ACCOUNT + "redefinirsenha/" + this.user.pessoaCNAId;
            },
            isIdle() {
                // console.log("isAppIdle", this.$root.isAppIdle);
                return this.$root.isAppIdle;
            },
        },

        methods: {
            getTermoUso: function () {
                this.dialogTermo = false;
                new Api("termouso/GetUltimoTermo")
                    .get({ attributeBehavior: "GetUltimoTermoUso" })
                    .then(
                        (data) => {
                            setTimeout(() => {
                                if (data.data) {
                                    this.termoUso = data.data;
                                    this.dialogTermo = true;
                                } else {
                                    this.dialogTermo = false;
                                }
                            }, 1000);
                        },
                        (err) => {
                            this.defaultErrorResult(err);
                        }
                    );
            },

            confirmTermodeUso(termo) {
                if (this.aceito)
                    new Api("termousopessoa")
                        .post({
                            PessoaId: termo.pessoaId,
                            TermoUsoId: termo.termoUsoId,
                            DataAceite: new Date(),
                        })
                        .then(
                            (data) => {
                                setTimeout(() => {
                                    this.defaultSuccessResult("Termo aceito com sucesso.");
                                    this.dialogTermo = false;
                                }, 1000);
                            },
                            (err) => {
                                this.defaultErrorResult(err);
                            }
                        );
                else {
                    this.defaultErrorResult(
                        "É necessário aceitar o Termo para continuar a compra",
                        true
                    );
                }
            },

            getImagensCarrossel(path) {
                new Api("banner")
                    .get({
                        urlPagina: path,
                        background: false,
                        ativo: true,
                        orderFields: "Ordem",
                        orderByType: 0,
                    })
                    .then(
                        (data) => {
                            this.imagens = data.dataList;
                        },
                        () => { }
                    );
            },
            logout() {                              
                Auth.logout();
            },
            goToPedidos() {

                if (this.cnaStore)
                    window.location.href = '/home';


                let el = document.getElementById("tab_pedidos");
                el.scrollIntoView();
            },
            goToLinkEncaminhado(urlEncaminhado) {
                //window.location.href = urlEncaminhado;
                if (urlEncaminhado != null && urlEncaminhado != '') {
                    window.open(urlEncaminhado, '_blank');
                }
            }
        },
        mounted() {
            this.cnaStore = Cache.get(Auth.ehCnaStore_key) == "true" ? true : false;
            this.user = Auth.currentUser();
            this.getImagensCarrossel(window.location.pathname);
            this.getTermoUso();

            //console.log("cna store", this.cnaStore);
        },
    };
</script>